// =====================================================
// ProfileChip.jsx the "who am I" chip for headers
//
//   Signed OUT:  ( 👤 Sign in )  -> opens SignInModal
//   Signed IN:   ( M  Hi Mike )  -> goes to /profile
//                                    (profile has sign-out)
//
// It reads useSession(), so it updates by itself the
// moment anyone signs in anywhere (modal, /signin page,
// AccountGate, or after tapping a ♥).
//
// Usage drop into any header or nav:
//   <ProfileChip />          on DARK backgrounds (your
//                            purple header / bottom bar)
//   <ProfileChip light />    on WHITE backgrounds
// =====================================================

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { useSession } from "./session";
import SignInModal from "./SignInModal";
import "./ProfileChip.css";

export default function ProfileChip({ light = false }) {
  const user = useSession();
  const navigate = useNavigate();
  const [signInOpen, setSignInOpen] = useState(false);

  /* ---------- signed out ---------- */

  if (!user) {
    return (
      <>
        <button
          type="button"
          className={`gpc-chip ${light ? "gpc-chip--light" : ""}`}
          onClick={() => setSignInOpen(true)}
        >
          <FaUserCircle
            className="gpc-guest-icon"
            aria-hidden="true"
          />
          <span className="gpc-name">Sign in</span>
        </button>

        {signInOpen && (
          <SignInModal
            isOpen={signInOpen}
            onClose={() => setSignInOpen(false)}
          />
        )}
      </>
    );
  }

  /* ---------- signed in ---------- */

  const name = user.firstName || user.email.split("@")[0];
  const initial = (user.firstName || user.email)
    .charAt(0)
    .toUpperCase();

  return (
    <button
      type="button"
      className={`gpc-chip gpc-chip--user ${
        light ? "gpc-chip--light" : ""
      }`}
      onClick={() => navigate("/profile")}
      aria-label={`Open profile for ${name}`}
      title={user.email}
    >
      <span className="gpc-avatar" aria-hidden="true">
        {initial}
      </span>
      <span className="gpc-name">Hi {name}</span>
    </button>
  );
}
